import Button from "components/button";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import ValueGrid from "components/grid/value-grid";
import Modal from "components/layout/modal";
import { ListEntity } from "models/list-entity";
import { EntityCollection } from "models/list-user-entity-collection";
import { FunctionComponent } from "react";

interface ViewModalProps {
  listEntity: ListEntity;
  entityCollection: EntityCollection;
  onClose: () => Promise<void>;
}

const ViewModal: FunctionComponent<ViewModalProps> = ({
  listEntity,
  entityCollection,
  onClose,
}) => {
  return (
    <Modal title="">
      <ValueGrid
        listEntityFields={listEntity.listEntityFields || []}
        entityCollections={[entityCollection]}
      />
      <Grid>
        <Row>
          <Col>
            <Button type="primary" onClick={onClose}>
              Sulje
            </Button>
          </Col>
        </Row>
      </Grid>
    </Modal>
  );
};

export default ViewModal;
